const anim = {};
// annim permet d'annimer toute valeur d'un objet avec les propriétés de easing ci-dessous

const easeFunctions = {
    none: t => t,
    power1: {
        in: t => t * t,
        out: t => 1 - (1 - t) * (1 - t),
        inout: t => t < 0.5 ? t * t * 2 : 1 - Math.pow(-2 * t + 2, 2) / 2,
    },
    power2: {
        in: t => t * t,
        out: t => 1 - (1 - t) * (1 - t),
        inout: t => t < 0.5 ? t * t * 2 : 1 - Math.pow(-2 * t + 2, 2) / 2,
    },
    power3: {
        in: t => t ** 3,
        out: t => 1 - (1 - t) ** 3,
        inout: t => t < 0.5 ? (t * 2) ** 3 / 2 : 1 - (2 - t * 2) ** 3 / 2,
    },
    power4: {
        in: t => t ** 4,
        out: t => 1 - (1 - t) ** 4,
        inout: t => t < 0.5 ? (t * 2) ** 4 / 2 : 1 - (2 - t * 2) ** 4 / 2,
    },
    back: {
        in: t => t * t * (2.70158 * t - 1.70158),
        out: t => 1 + (--t) * t * (2.70158 * t + 1.70158),
        inout: t => {
            const c1 = 1.70158 * 1.525;
            const c3 = c1 + 1;
            return t < 0.5 ?
                (2 * t) ** 2 * ((c3 + 1) * 2 * t - c3) / 2 :
                ((2 * t - 2) ** 2 * ((c3 + 1) * (t * 2 - 2) + c3) + 2) / 2;
        },
    }
};
anim.to = (
    element,
    {
        duration = 1,
        easing = "none",
        onComplete = () => { },
        onUpdate = (progress) => { },
        ...properties
    }
) => {
    const [easeKey, easeFunction] = easing.split('.');

    if (!(easeKey in easeFunctions)) {
        console.error(`La clé "${easeKey}" n'existe pas dans l'objet easeFunctions.`);
        return;
    }

    const selectedEaseFunction = easeFunctions[easeKey]?.[easeFunction] || easeFunctions.none;

    const startValues = {};
    const ranges = {};

    for (const prop in properties) {
        startValues[prop] = element[prop] ?? 0;
        ranges[prop] = properties[prop] - startValues[prop];
    }

    duration *= 1000;

    let elapsed = 0;
    let previousTime = performance.now();
    let rafId = null;
    let killed = false;

    const tick = (now) => {
        if (killed) return;

        const delta = now - previousTime;
        previousTime = now;

        const safeDelta = Math.min(delta, 100);
        elapsed += safeDelta;

        let progress = Math.min(elapsed / duration, 1);
        const easedProgress = selectedEaseFunction(progress);

        for (const prop in properties) {
            element[prop] = startValues[prop] + ranges[prop] * easedProgress;
        }

        onUpdate(easedProgress);

        if (progress < 1) {
            rafId = requestAnimationFrame(tick);
        } else {
            onComplete();
        }
    };

    rafId = requestAnimationFrame(tick);

    // Renvoie un objet pour pouvoir tuer l'animation
    return {
        kill: () => {
            killed = true;
            if (rafId !== null) {
                cancelAnimationFrame(rafId);
            }
        }
    };
};


/**
 * exemple de code : 
 * 
 * annim.to(
    torusKnot.position, 
    {  duration:2 , x:3, easing: 'power1.in'}
)
annim.to(material, {opacity:1, duration:2})
 */
export default anim;
